import type { Action } from "../../actions/types";

export interface StoreState {
  [index: string]: {
    code: string;
    id: string;
    merchantId: string;
  };
}

export const initialState = null;

export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_SHARE_SUCCESS") {
    const channel = action.response.data.channel;

    return { ...state, [channel]: action.response.data };
  }

  return state;
}
